import AuthGuest from "../AuthGuest"
import { API_PUBLIC } from "@/app/contants/url"

const SubscribeService = {
  subscribeEmail: (payload: any): AwaitStatusResponse<any> => AuthGuest().post(`${API_PUBLIC}subscribe`, payload),
  confirmCode: (token: string): AwaitStatusResponse<any> => AuthGuest().get(`${API_PUBLIC}subscribe/confirm/${token}`),
  sendMessage: (payload: any): AwaitStatusResponse<any> => AuthGuest().post(`${API_PUBLIC}send-message`, payload)
}
export default SubscribeService
